export default {
  subtitle: "International Bank Accounts",
  path: "bank_accounts_intl",
  paragraph: "Your first international account will be created during the onboarding process, based on the details provided in your contract. If you wish to register an additional account, you can use this endpoint. Please note that international accounts are only available in USD or EUR.",
  request:  {
    method: "POST",
    endpoint: "/bank_accounts",
    payload: {
      "bank_account": {
        "account_number": "852077",
        "owner_document_number": "01472583691",
        "owner_document_type": "tax_id",
        "owner_name": "Company Ltd.",
        "bank": {
          "name": "International Bank",
          "swift": "CHASUS33"
        },
        "currency": "USD",
        "routing_number": "0015687456"
      }
    },
    responses: {
        "data": {
            "routing_number": "0015687456",
            "pix_info": null,
            "owner_name": "Company Ltd.",
            "owner_document_type": "tax_id",
            "owner_document_number": "01472583691",
            "owner_company": {
                "social_name": "Company Ltd.",
                "id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2",
                "document_type": "tax_id",
                "document_number": "01472583691"
            },
            "nickname": null,
            "intermediary_bank_account": null,
            "id": "8bc686a0-c998-4492-a3f8-c32dcdb4029a",
            "iban": null,
            "currency": "USD",
            "branch_number": null,
            "branch_country": null,
            "bank": {
                "swift": "CHASUS33",
                "name": "International Bank",
                "ispb": null,
                "id": "f628acf0-42aa-4313-afc0-e454520648af",
                "country": null,
                "code": null
            },
            "account_type": "conta-corrente",
            "account_number": "852077",
            "aba": null
        }
    }
  },

  parameterPayload: [
    {
      name: "bank_account",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },
    {
      name: "bank_account.account_number",
      type: "string",
      required: true,
      description: "Account number",
    },
    {
      name: "bank_account.owner_document_number",
      type: "string",
      required: true,
      description: "Account owner document number",
    },
    {
      name: "bank_account.owner_name",
      type: "string",
      required: true,
      description: "Account owner full name",
    },
    {
      name: "bank_account.currency",
      type: "string",
      required: true,
      description: "Account currency (ISO 4217 format)",
    },
    {
      name: "bank_account.routing_number",
      type: "string",
      required: false,
      description: "Routing number",
    },
    {
      name: "bank_account.bank",
      type: "object",
      required: true,
      description: "an object containing:",
      is_parent: true
    },
    {
      name: "bank_account.bank.name",
      type: "string",
      required: true,
      description: "Bank name",
    },
    {
      name: "bank_account.bank.swift",
      type: "string",
      required: true,
      description: "Bank Swift code",
    }
  ],

  footerNotes: "If a previously registered swift code is provided, its corresponding bank name will be overwritten with the recorded bank name from our database."
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/BankAccountsRegistrationINT.js